import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessKx3124qexParamStatus: 'idle',
    startProcessKx3124qexParamError: undefined as any,
    loadUserParamsProcessKx3124qexParamStatus: 'idle',
    loadUserParamsProcessKx3124qexParamError: undefined as any,

    processKx3124qexParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessKx3124qexParam = createAsyncThunk('processKx3124qexParamSlice/startProcessKx3124qexParam', async ({ processKx3124qexParam }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessKx3124qexParam/`,
        prepareData(processKx3124qexParam),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessKx3124qexParamStatus } = getState().processKx3124qexParamSlice
        return startProcessKx3124qexParamStatus !== 'pending'
    }
})

export const loadUserParamsProcessKx3124qexParam = createAsyncThunk('processKx3124qexParamSlice/loadUserParamsProcessKx3124qexParam', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessKx3124qexParam/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessKx3124qexParamStatus } = getState().processKx3124qexParamSlice
        return loadUserParamsProcessKx3124qexParamStatus !== 'pending'
    }
})

const ProcessKx3124qexParamSlice = createSlice({
    name: 'processKx3124qexParamSlice',
    initialState,
    reducers: {
        resetstartProcessKx3124qexParam: (state) => {
            state.job = undefined
            state.startProcessKx3124qexParamError = undefined
        },
        resetstartProcessKx3124qexParamError: (state) => {
            state.startProcessKx3124qexParamError = undefined
        },
        resetloadUserParamsProcessKx3124qexParam: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessKx3124qexParamError = undefined
        },
        resetloadUserParamsProcessKx3124qexParamError: (state) => {
            state.loadUserParamsProcessKx3124qexParamError = undefined
        },
        removeFromProcessKx3124qexParamListById: (state, action) => {
            state.processKx3124qexParamList = state.processKx3124qexParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessKx3124qexParamListByIds: (state, action) => {
            state.processKx3124qexParamList = state.processKx3124qexParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processKx3124qexParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessKx3124qexParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processKx3124qexParamList = []
            state.startProcessKx3124qexParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessKx3124qexParam.pending, (state) => {
            state.startProcessKx3124qexParamStatus = 'pending'
            state.startProcessKx3124qexParamError = undefined
        })
        builder.addCase(startProcessKx3124qexParam.fulfilled, (state, action) => {
            state.startProcessKx3124qexParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessKx3124qexParam.rejected, (state, action) => {
            state.startProcessKx3124qexParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessKx3124qexParamError = action.error.message
            } else {
                state.startProcessKx3124qexParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessKx3124qexParam.pending, (state) => {
            state.loadUserParamsProcessKx3124qexParamStatus = 'pending'
            state.loadUserParamsProcessKx3124qexParamError = undefined
        })
        builder.addCase(loadUserParamsProcessKx3124qexParam.fulfilled, (state, action) => {
            state.loadUserParamsProcessKx3124qexParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessKx3124qexParam.rejected, (state, action) => {
            state.loadUserParamsProcessKx3124qexParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessKx3124qexParamError = action.error.message
            } else {
                state.loadUserParamsProcessKx3124qexParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessKx3124qexParam,
    resetstartProcessKx3124qexParamError,
    resetloadUserParamsProcessKx3124qexParam,
    resetloadUserParamsProcessKx3124qexParamError,
    removeFromProcessKx3124qexParamListById,
    removeFromProcessKx3124qexParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessKx3124qexParamSlice.actions
export default ProcessKx3124qexParamSlice.reducer
